import React from 'react';
import './Section.css';

const Section = ({ children, className = '', id, style }) => {
  return (
    <section id={id} className={`section ${className}`} style={style}>
      <div className="section-container">
        {children}
      </div>
    </section>
  );
};

export default Section;

